<template>
  <img v-if="data.logo && data.logo.image_url!=null" width="220" height="64" :src="data.logo.image_url" :class="{ inherited: data.logo.inherited }"/>
  <div class="logo-preview" v-else-if="data.logo" :class="{ inherited: data.logo.inherited }"
    :style="{
      fontSize: data.logo.size,
      fontStyle: (data.logo.italic) ? 'italic' : 'normal',
      fontWeight: (data.logo.bold) ? 'bold' : 'normal',
      fontFamily: data.logo.font,
      color: data.logo.color,
      backgroundColor: data.logo.background,
    }"
  >{{data.logo.text}}
  </div>
</template>

<script>
  export default {
    name: 'LogoItem',

    props: {
      data: {
        type: Object,
        required: true,
      }
    },

    computed:{
      imageUrl(){
        return window.serverUrl+this.data.logo.image_url
      }
    }

  }
</script>

<style scoped>
  .logo-preview {
    width: 220px;
    height: 64px;
    margin: 5px;
    line-height: 64px;
    text-align: center;
    padding: 0 10px;
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Logo/LogoItem.vue